"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Code = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Code = function Code() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.36 4.028l.97.369h-.04a.499.499 0 01.3.628l-5.31 14.648a.51.51 0 01-.64.3l-.94-.34a.499.499 0 01-.3-.638l5.31-14.668a.52.52 0 01.65-.3zM4.33 12.01l3.44-3.432a.488.488 0 000-.699l-.71-.708a.5.5 0 00-.71 0l-4.13 4.12a.767.767 0 00-.22.53v.379c0 .198.08.388.22.529l4.14 4.12a.5.5 0 00.71 0l.71-.698a.498.498 0 000-.708L4.33 12.01zM22 12.2a.767.767 0 01-.22.529l-4.14 4.12a.5.5 0 01-.71 0l-.71-.708a.488.488 0 010-.698l3.45-3.433-3.45-3.432a.498.498 0 010-.709l.71-.698a.5.5 0 01.71 0l4.14 4.12c.14.141.22.331.22.53v.379z",
    clipRule: "evenodd"
  });
};

exports.Code = Code;